import axios from 'axios';
import qs from 'qs';
import { IMyCharListConfig, ICharacterList, ICharacterItem } from '../interface/IMyCharList';
import { _getCharacterInfoByService } from './characterInfo';

/**
 * @alias MyCharList
 * @category MyCharList
 * @param localeCountry {string} - optional
 * @example
 * if (window.ncui && window.ncui.myCharList) {
 *    const myCharList = new window.ncui.myCharList({ localeCountry: 'kr' });
 *    cnbConfig.charChangeFN = myCharList.setCharacterChangeFunction.bind(myCharList);
 * }
 */

export default class Index {
    private ApiUrl: string;
    private onRequest: boolean;

    constructor({ localeCountry }: IMyCharListConfig) {
        // console.log('-------MyCharList START-------', _config);
        this.ApiUrl = `${location.origin}${localeCountry ? `/${localeCountry}` : ''}/my/profile`;
        this.onRequest = false;
    }

    // 캐릭터 리스트 불러오는 함수
    public async setCharacterChangeFunction(): Promise<void> {
        try {
            const { data } = await axios.get(`${this.ApiUrl}/characters`);
            const characterWrapper = document.querySelector('.ncc-character-panel .ncc-character-list');
            if (!(characterWrapper instanceof HTMLUListElement)) return;
            characterWrapper.innerHTML = this.markupCharacterList(data);
            this.setSelectCharacterEvent();
        } catch (error) {
            console.log(error);
        }
    }

    private markupCharacterList(charcterList: ICharacterList): string {
        let characterListElement = '';
        Object.values(charcterList).forEach((characters) => {
            let characterItem = '';
            characters.forEach((character: ICharacterItem, index) => {
                if (index === 0) characterItem += `<li class="ncc-character-item"><a href="#">${character.serverName}</a>`;
                const characeterItem = `
                    <ul class="ncc-lnb-item__sub is-active">
                        <li class="cnb-character-list-items">
                            <div class="character-info">
                            <a
                                href="javascript:;"
                                data-setUserRepresentativeInfo-serverId="${character.serverId}"
                                data-setUserRepresentativeInfo-characterId="${character.characterId}"
                            >
                                <span class="character">
                                    ${_getCharacterInfoByService(character)}
                                </span>
                            </a>
                            </div>
                        </li>
                    </ul>`;
                characterItem += characeterItem;
            });
            characterListElement += characterItem + '</li>';
        });
        return characterListElement;
    }

    // [data-setuserrepresentativeinfo-serverid]를 가진 태그에 클릭 이벤트
    private setSelectCharacterEvent(): void {
        document.querySelectorAll('[data-setuserrepresentativeinfo-serverid]').forEach((characterElement: Element) => {
            characterElement.addEventListener('click', () => this._selectCharacterEventHandler(characterElement));
        });
    }

    // 캐릭터 클릭시 호출하는 API
    private async _selectCharacterEventHandler(characterElement: Element): Promise<void> {
        if (this.onRequest) return;
        try {
            this.onRequest = true;
            await axios.post(
                `${this.ApiUrl}/userRepresentativeInfo`,
                qs.stringify({
                    serverId: characterElement.getAttribute('data-setUserRepresentativeInfo-serverId'),
                    characterId: characterElement.getAttribute('data-setUserRepresentativeInfo-characterid'),
                }),
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );
            location.reload();
        } catch (error) {
            console.log(error);
        }
    }
} // end of class
